module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAASdJREFUOE+d0jFLw0AUB/D/S3TLt3DQb6CbCi4x4mJF0nSIW3FxulhwsIKD9FxcpINgF1NEF4cmS0Hd9Bu4+C3qpHdPLtJi6aWiN957P/73jkf456EyF0TJITNmsrR1bOuxwvVqckTAmilqoG/DE3CI3j8GvknyZr3chsfgT/R4ezEwcGV7z7PhEbSh4Ww2XMBpqAzTZi2ZV4xXZr5khdP8Rr7ZftHfEXPkokGgWCte+E4MxRYRTjSjnnfl00ZN7LOm2NQY3MlSee6HYtkhtBncyNKz+9GMQSQetEbTwCA6uPpU6s5A16FKlsrdAjpo9q7lqrkvhVrrTtFAiH+HQJuV++K6WmpwkeiAKko5gly16AD1ycRq0mVgadrqEvDcS1vh2FP/uutfjZ+mRw+n+C8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Icon/HomeOutlined.png
// module id = rjXV
// module chunks = 82